import React from "react"
import {observer} from "mobx-react"
import {Link} from "react-router-dom"
import Price from "components/Price/Price"
import DropdownQuantities from "components/Product/DropdownQuantities"
import ProductCount from "components/Product/ProductCount"
import PropTypes from "prop-types"
import ProductRowCartAction from "components/Product/ProductRowCartAction"
import ListActions from "components/Product/ProductRowListAction"

const ProductRowDefault = observer(( { product, onChange, list, cart } ) => {
	return (
		<tr>
			<td>
				{cart ? <ProductRowCartAction cart={cart} product={product}/> : null}
			</td>
			<td>
				<Link to={`/product/${product.map_id}`}>
					<img
						className="db center"
						height="34"
						src={product.img_src_small}
						alt=""/>
				</Link>
			</td>
			<td className={"td-title"}>
				<Link to={`/product/${product.map_id}`}>
					<strong>{product.article_nr}</strong> <span className="product-title">{product.title}</span> <br/>
					<span className="unit_multi black-50 f6">{product.extraValue.veextrainfo || <span>
						VE {product.unit_multi} {translate( "cart.piece" )}
					</span>}</span>
				</Link>
			</td>
			<td className={"td-availability"}><span className="f6">{product.getNotice( "tiny" )}</span></td>
			<td><Price>{product.price}</Price></td>
			<td><Price>{product.price * product.unit_multi}</Price></td>
			<td> {product.unit_multi * product.count} {translate( "cart.piece" )}</td>
			<td><Price>{product.price * product.count * product.unit_multi}</Price></td>
			<td><DropdownQuantities product={product} onChange={onChange}/></td>
			<td className="tr">
				<ProductCount product={product} onChange={onChange}/>
			</td>
			{list && <td>
				<div className="fr"><ListActions list={list} product={product}/></div>
			</td>}
		</tr>
	)
})
export default ProductRowDefault

ProductRowDefault.propTypes = {
	index:    PropTypes.any,
	list:     PropTypes.object,
	cart:     PropTypes.object,
	onChange: PropTypes.func,
	product:  PropTypes.any,
}



// WEBPACK FOOTER //
// ./src/components/Product/ProductRowDefault.js